import _regenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _toConsumableArray from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _objectSpread from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _typeof from "/Users/shorlyn/Documents/project/core/campus-all/rccms-web/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.reduce.js";
import "core-js/modules/es.iterator.some.js";
import "core-js/modules/es.number.is-nan.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getMyChatList, syncMessages, getHistoryMessages, postMessage, postGroupMessage, getMessageAck, postRead, createChat, recallMessage } from '@/api/chat';
import Vue from 'vue';
import desktopNotify from '@/utils/desktop-notify';

/**
 * IM 消息 Vuex Store
 */

var state = {
  chats: [],
  // 会话列表
  currentChatId: null,
  // 当前选中会话
  messages: {},
  // chatId -> messages[]
  historyStates: {},
  // chatId -> { page: 1, hasMore: true } （历史记录拉取状态）
  unreadCount: 0,
  // 总未读
  drawerOpen: false,
  // Drawer 是否打开
  pendingToast: null // 待弹 toast 的消息 { chatId, senderName, content }
};

// 同一 chat 3秒内合并，不重复弹
var _toastThrottleMap = {};
function normalizeKeys(value) {
  if (Array.isArray(value)) {
    return value.map(function (item) {
      return normalizeKeys(item);
    });
  }
  if (value && _typeof(value) === 'object') {
    return Object.keys(value).reduce(function (acc, key) {
      acc[(key || '').toLowerCase()] = normalizeKeys(value[key]);
      return acc;
    }, {});
  }
  return value;
}
function buildStructuredCardPayload(message) {
  var content = message === null || message === void 0 ? void 0 : message.content;
  var raw = null;
  var parsedFromStructuredContent = false;
  if (content && _typeof(content) === 'object') {
    raw = content;
    parsedFromStructuredContent = true;
  } else if (typeof content === 'string') {
    var trimmed = content.trim();
    if (trimmed.startsWith('{') || trimmed.startsWith('[')) {
      try {
        raw = JSON.parse(trimmed);
        parsedFromStructuredContent = true;
      } catch (_) {
        raw = null;
      }
    }
  }
  var normalized = normalizeKeys(raw || {});
  var extra = normalized.extra || {};
  var actions = Array.isArray(normalized.actions) ? normalized.actions : [];
  var deepLink = normalized.deeplink || extra.deeplink || (message === null || message === void 0 ? void 0 : message.link) || extra.link || extra.applink || '';
  var title = normalized.title || extra.title || extra.processname || '';
  var summary = normalized.summary || normalized.actiontext || extra.actiontext || '';
  var type = normalized.type || normalized.cardtype || '';
  var hasStructuredMarker = !!type || !!normalized.cardtype || !!normalized.type || !!normalized.actions || !!normalized.extra || !!normalized.processid || !!normalized.bizid || !!normalized.biztype || !!normalized.currenthandler || !!normalized.initiatorname || !!normalized.actiontext;
  if (!parsedFromStructuredContent || !hasStructuredMarker) return null;
  if (!type && !title && !summary && !deepLink) return null;
  return {
    _isStructuredCard: true,
    type: type || 'card',
    title: title || (message === null || message === void 0 ? void 0 : message.title) || '系统通知',
    summary: summary,
    status: normalized.status || '',
    actions: actions.map(function (action) {
      return {
        key: action.key,
        text: action.text,
        deepLink: action.deeplink
      };
    }),
    deepLink: deepLink,
    extra: {
      processId: normalized.processid || extra.processid,
      bizId: normalized.bizid || extra.bizid,
      bizType: normalized.biztype || extra.biztype,
      initiatorName: normalized.initiatorname || extra.initiatorname,
      currentHandler: normalized.currenthandler || extra.currenthandler,
      actionText: normalized.actiontext || extra.actiontext,
      createdTime: normalized.createdtime || normalized.occurredat || extra.createdtime || extra.occurredat,
      deepLink: deepLink
    }
  };
}
function isGroupChat(chat) {
  return (chat === null || chat === void 0 ? void 0 : chat.type) === 2 || (chat === null || chat === void 0 ? void 0 : chat.isGroupChat) === true || (chat === null || chat === void 0 ? void 0 : chat.receiveType) === 9 || (chat === null || chat === void 0 ? void 0 : chat.userType) === 9;
}
function buildSendInput(_ref) {
  var chatId = _ref.chatId,
    chat = _ref.chat,
    user = _ref.user,
    messageType = _ref.messageType,
    content = _ref.content,
    link = _ref.link,
    clientMsgId = _ref.clientMsgId;
  var groupChat = isGroupChat(chat);
  return {
    chatId: chatId,
    senderId: user.userId,
    senderType: 1,
    senderName: user.name,
    receiveId: groupChat ? null : (chat === null || chat === void 0 ? void 0 : chat.userId) || 0,
    receiveType: groupChat ? 9 : (chat === null || chat === void 0 ? void 0 : chat.userType) || 1,
    receiveName: (chat === null || chat === void 0 ? void 0 : chat.name) || '',
    messageType: messageType,
    content: content,
    link: link || '',
    clientMsgId: clientMsgId
  };
}
function postChatMessage(chat, input) {
  return isGroupChat(chat) ? postGroupMessage(input) : postMessage(input);
}
function readInt(value) {
  if (typeof value === 'number') return value;
  var parsed = parseInt(value, 10);
  return Number.isNaN(parsed) ? 0 : parsed;
}
function normalizeIncomingMessage(message) {
  var normalized = _objectSpread({}, message);
  var cardPayload = buildStructuredCardPayload(normalized);
  if (cardPayload) {
    normalized._cardPayload = cardPayload;
  }
  return normalized;
}
function buildChatMetaPatchFromMessage(message) {
  var content = String((message === null || message === void 0 ? void 0 : message.content) || '').trim();
  if (!content) return null;
  if (/已开启全员禁言/.test(content)) {
    return {
      isAllMuted: true
    };
  }
  if (/已关闭全员禁言/.test(content)) {
    return {
      isAllMuted: false
    };
  }
  return null;
}
function buildDesktopNotifyBody(message) {
  var messageType = message === null || message === void 0 ? void 0 : message.messageType;
  var content = String((message === null || message === void 0 ? void 0 : message.content) || '').trim();
  if (messageType === 1) {
    if (!content) return '发来一条消息';
    return content.length > 48 ? "".concat(content.slice(0, 48), "...") : content;
  }
  return '发来一条消息';
}
function resolveDesktopNotifyIcon() {
  var _window$location;
  if (typeof window === 'undefined' || !((_window$location = window.location) !== null && _window$location !== void 0 && _window$location.origin)) return '';
  return "".concat(window.location.origin, "/favicon.ico");
}
var mutations = {
  SET_CHATS: function SET_CHATS(state, chats) {
    state.chats = Array.isArray(chats) ? chats : [];
    // 使用后端返回的 unreadCount
    state.unreadCount = state.chats.reduce(function (sum, c) {
      return sum + (c.unreadCount || 0);
    }, 0);
  },
  SET_DRAWER_OPEN: function SET_DRAWER_OPEN(state, open) {
    state.drawerOpen = open;
  },
  SET_PENDING_TOAST: function SET_PENDING_TOAST(state, toast) {
    state.pendingToast = toast;
  },
  SET_CURRENT_CHAT: function SET_CURRENT_CHAT(state, chatId) {
    state.currentChatId = chatId;
  },
  SET_MESSAGES: function SET_MESSAGES(state, _ref2) {
    var chatId = _ref2.chatId,
      messages = _ref2.messages;
    // 保证分配全新的数组引用，触发视图更新
    Vue.set(state.messages, chatId, _toConsumableArray(messages || []));
  },
  APPEND_MESSAGES: function APPEND_MESSAGES(state, _ref3) {
    var chatId = _ref3.chatId,
      messages = _ref3.messages;
    var existing = state.messages[chatId] || [];
    // 去重
    var existingKeys = new Set(existing.map(function (m) {
      return m.serverSeq ? String(m.serverSeq) : m.id || m.clientMsgId;
    }));
    var newMsgs = messages.filter(function (m) {
      var key = m.serverSeq ? String(m.serverSeq) : m.id || m.clientMsgId;
      return !existingKeys.has(key);
    });
    // 保证分配全新的数组引用
    Vue.set(state.messages, chatId, [].concat(_toConsumableArray(existing), _toConsumableArray(newMsgs)));
  },
  SET_HISTORY_STATE: function SET_HISTORY_STATE(state, _ref4) {
    var chatId = _ref4.chatId,
      page = _ref4.page,
      hasMore = _ref4.hasMore;
    Vue.set(state.historyStates, chatId, {
      page: page,
      hasMore: hasMore
    });
  },
  PREPEND_MESSAGES: function PREPEND_MESSAGES(state, _ref5) {
    var chatId = _ref5.chatId,
      messages = _ref5.messages;
    var existing = state.messages[chatId] || [];
    var existingKeys = new Set(existing.map(function (m) {
      return m.serverSeq ? String(m.serverSeq) : m.id || m.clientMsgId;
    }));
    // 历史消息默认是 DESC（最新在前），因为要拼在本地前面，所以翻转为 ASC
    var newMsgs = _toConsumableArray(messages).reverse().filter(function (m) {
      var key = m.serverSeq ? String(m.serverSeq) : m.id || m.clientMsgId;
      return !existingKeys.has(key);
    });
    Vue.set(state.messages, chatId, [].concat(_toConsumableArray(newMsgs), _toConsumableArray(existing)));
  },
  PUSH_MESSAGE: function PUSH_MESSAGE(state, _ref6) {
    var chatId = _ref6.chatId,
      message = _ref6.message;
    var existing = state.messages[chatId] || [];
    // 去重: 如果已存在相同 clientMsgId 则替换（pending → confirmed）
    var idx = existing.findIndex(function (m) {
      return m.clientMsgId === message.clientMsgId;
    });
    if (idx >= 0) {
      Vue.set(existing, idx, message);
    } else {
      existing.push(message);
    }
    Vue.set(state.messages, chatId, existing);
  },
  UPDATE_MESSAGE_LOCAL_STATE: function UPDATE_MESSAGE_LOCAL_STATE(state, _ref7) {
    var chatId = _ref7.chatId,
      matcher = _ref7.matcher,
      patch = _ref7.patch;
    var existing = state.messages[chatId] || [];
    var idx = existing.findIndex(function (m) {
      if (matcher.clientMsgId) return m.clientMsgId === matcher.clientMsgId;
      if (matcher.id) return m.id === matcher.id;
      if (matcher.serverSeq) return m.serverSeq === matcher.serverSeq;
      return false;
    });
    if (idx >= 0) {
      Vue.set(existing, idx, _objectSpread(_objectSpread({}, existing[idx]), patch));
      Vue.set(state.messages, chatId, _toConsumableArray(existing));
    }
  },
  UPDATE_CHAT_LAST_MESSAGE: function UPDATE_CHAT_LAST_MESSAGE(state, _ref8) {
    var chatId = _ref8.chatId,
      content = _ref8.content,
      time = _ref8.time,
      maxSeq = _ref8.maxSeq;
    var chat = state.chats.find(function (c) {
      return c.id === chatId;
    });
    if (chat) {
      chat.lastMessage = content;
      chat.lastMessageTime = time;
      if (maxSeq) chat.maxSeq = maxSeq;
    }
  },
  UPDATE_CHAT_META: function UPDATE_CHAT_META(state, _ref9) {
    var chatId = _ref9.chatId,
      patch = _ref9.patch;
    var chat = state.chats.find(function (c) {
      return c.id === chatId;
    });
    if (chat && patch && _typeof(patch) === 'object') {
      Object.keys(patch).forEach(function (key) {
        Vue.set(chat, key, patch[key]);
      });
    }
  },
  UPDATE_READ_CURSOR: function UPDATE_READ_CURSOR(state, _ref0) {
    var chatId = _ref0.chatId,
      readSeq = _ref0.readSeq;
    var chat = state.chats.find(function (c) {
      return c.id === chatId;
    });
    if (chat) {
      chat.myReadSeq = Math.max(chat.myReadSeq || 0, readSeq);
      chat.unreadCount = Math.max(0, (chat.maxSeq || 0) - chat.myReadSeq);
    }
    // 重算总未读
    state.unreadCount = state.chats.reduce(function (sum, c) {
      return sum + (c.unreadCount || 0);
    }, 0);
  },
  ADD_CHAT: function ADD_CHAT(state, chat) {
    // 去重
    if (!state.chats.find(function (c) {
      return c.id === chat.id;
    })) {
      state.chats.unshift(chat);
    }
  },
  RECALL_MESSAGE: function RECALL_MESSAGE(state, _ref1) {
    var chatId = _ref1.chatId,
      messageId = _ref1.messageId,
      serverSeq = _ref1.serverSeq;
    var msgs = state.messages[chatId] || [];
    var idx = msgs.findIndex(function (m) {
      return m.id === messageId || m.serverSeq === serverSeq;
    });
    if (idx >= 0) {
      var msg = msgs[idx];
      Vue.set(msgs, idx, _objectSpread(_objectSpread({}, msg), {}, {
        status: 1,
        content: '已撤回'
      }));
      var chat = state.chats.find(function (c) {
        return c.id === chatId;
      });
      if (chat && msg.serverSeq && chat.maxSeq && msg.serverSeq === chat.maxSeq) {
        chat.lastMessage = '撤回了一条消息';
        chat.lastMessageTime = msg.updatedTime || msg.createdTime || chat.lastMessageTime;
      }
    }
  }
};
var actions = {
  /**
   * 加载会话列表
   */
  loadChats: function loadChats(_ref10) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var commit, res, raw, list, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref10.commit;
            _context.p = 1;
            _context.n = 2;
            return getMyChatList({
              page: 1,
              size: 100
            });
          case 2:
            res = _context.v;
            raw = res.data || res;
            list = Array.isArray(raw) ? raw : Array.isArray(raw.list) ? raw.list : Array.isArray(raw.items) ? raw.items : Array.isArray(raw.result) ? raw.result : [];
            commit('SET_CHATS', list);
            _context.n = 4;
            break;
          case 3:
            _context.p = 3;
            _t = _context.v;
            console.error('[Chat] loadChats failed:', _t);
          case 4:
            return _context.a(2);
        }
      }, _callee, null, [[1, 3]]);
    }))();
  },
  /**
   * 加载历史消息 (向上滚动)
   */
  loadHistory: function loadHistory(_ref11, chatId) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var commit, state, hs, cachedMsgs, beforeSeq, seqs, minSeq, nextPage, _res$data, _res$data2, apiPage, res, rawMsgs, msgs, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref11.commit, state = _ref11.state;
            hs = state.historyStates[chatId] || {
              page: 0,
              hasMore: true
            };
            if (hs.hasMore) {
              _context2.n = 1;
              break;
            }
            return _context2.a(2, 0);
          case 1:
            // 计算 beforeSeq 游标
            cachedMsgs = state.messages[chatId] || [];
            beforeSeq = null;
            if (cachedMsgs.length > 0) {
              seqs = cachedMsgs.map(function (m) {
                return m.serverSeq;
              }).filter(function (s) {
                return s > 0;
              });
              if (seqs.length > 0) {
                minSeq = Math.min.apply(Math, _toConsumableArray(seqs));
                if (minSeq > 0 && minSeq !== Infinity) {
                  beforeSeq = minSeq;
                }
              }
            }
            nextPage = hs.page + 1;
            _context2.p = 2;
            // 如果使用了 beforeSeq 游标分页，页码必须传 1，避免数据库发生 OFFSET 偏移导致漏数据
            apiPage = beforeSeq ? 1 : nextPage;
            _context2.n = 3;
            return getHistoryMessages({
              chatId: chatId,
              page: apiPage,
              size: 50,
              beforeSeq: beforeSeq
            });
          case 3:
            res = _context2.v;
            rawMsgs = ((_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.items) || ((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : _res$data2.list) || res.data || [];
            msgs = (Array.isArray(rawMsgs) ? rawMsgs : []).map(normalizeIncomingMessage);
            commit('SET_HISTORY_STATE', {
              chatId: chatId,
              page: nextPage,
              hasMore: msgs.length >= 50
            });
            if (msgs.length > 0) {
              commit('PREPEND_MESSAGES', {
                chatId: chatId,
                messages: msgs
              });
            }
            return _context2.a(2, msgs.length);
          case 4:
            _context2.p = 4;
            _t2 = _context2.v;
            console.error('[Chat] loadHistory failed:', _t2);
            return _context2.a(2, 0);
        }
      }, _callee2, null, [[2, 4]]);
    }))();
  },
  /**
   * 选择会话并增量加载消息
   */
  selectChat: function selectChat(_ref12, chatId) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
      var commit, state, dispatch, cachedMsgs, hasHistoryState, allMsgs, maxSeq, _res$data3, afterSeq, res, msgs, _allMsgs, _maxSeq, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref12.commit, state = _ref12.state, dispatch = _ref12.dispatch;
            commit('SET_CURRENT_CHAT', chatId);
            cachedMsgs = state.messages[chatId] || [];
            hasHistoryState = !!state.historyStates[chatId];
            _context3.p = 1;
            if (!(!hasHistoryState || cachedMsgs.length === 0)) {
              _context3.n = 3;
              break;
            }
            _context3.n = 2;
            return dispatch('loadHistory', chatId);
          case 2:
            // 更新游标
            allMsgs = state.messages[chatId] || [];
            if (allMsgs.length > 0) {
              maxSeq = Math.max.apply(Math, _toConsumableArray(allMsgs.map(function (m) {
                return m.serverSeq || 0;
              })));
              if (maxSeq > 0) {
                commit('UPDATE_READ_CURSOR', {
                  chatId: chatId,
                  readSeq: maxSeq
                });
              }
            }
            _context3.n = 5;
            break;
          case 3:
            // 已有本地缓存时，通过 sync 接口向前增量拉取最新消息
            afterSeq = Math.max.apply(Math, _toConsumableArray(cachedMsgs.map(function (m) {
              return m.serverSeq || 0;
            })));
            _context3.n = 4;
            return syncMessages({
              chatId: chatId,
              afterSeq: afterSeq,
              limit: 50
            });
          case 4:
            res = _context3.v;
            msgs = (((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : _res$data3.messages) || res.data || []).map(normalizeIncomingMessage);
            if (Array.isArray(msgs) && msgs.length > 0) {
              commit('APPEND_MESSAGES', {
                chatId: chatId,
                messages: msgs
              });
            }

            // 更新引用触发视图检测
            _allMsgs = state.messages[chatId] || [];
            if (_allMsgs.length > 0) {
              _maxSeq = Math.max.apply(Math, _toConsumableArray(_allMsgs.map(function (m) {
                return m.serverSeq || 0;
              })));
              if (_maxSeq > 0) {
                commit('UPDATE_READ_CURSOR', {
                  chatId: chatId,
                  readSeq: _maxSeq
                });
              }
            }
          case 5:
            _context3.n = 7;
            break;
          case 6:
            _context3.p = 6;
            _t3 = _context3.v;
            console.error('[Chat] selectChat sync failed:', _t3);
          case 7:
            return _context3.a(2);
        }
      }, _callee3, null, [[1, 6]]);
    }))();
  },
  /**
   * 发送消息（乐观插入 → HTTP → 确认）
   */
  sendMessage: function sendMessage(_ref13, _ref14) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      var commit, state, rootState, dispatch, chatId, content, user, clientMsgId, chat, input, pendingMsg, res, result, recovered, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref13.commit, state = _ref13.state, rootState = _ref13.rootState, dispatch = _ref13.dispatch;
            chatId = _ref14.chatId, content = _ref14.content;
            user = rootState.user;
            clientMsgId = 'web_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6); // 查找会话获取接收方信息
            chat = state.chats.find(function (c) {
              return c.id === chatId;
            });
            input = buildSendInput({
              chatId: chatId,
              chat: chat,
              user: user,
              messageType: 1,
              content: content,
              clientMsgId: clientMsgId
            }); // 乐观插入
            pendingMsg = _objectSpread(_objectSpread({}, input), {}, {
              serverSeq: null,
              createdTime: new Date().toLocaleString(),
              _pending: true
            });
            commit('PUSH_MESSAGE', {
              chatId: chatId,
              message: pendingMsg
            });
            _context4.p = 1;
            _context4.n = 2;
            return postChatMessage(chat, input);
          case 2:
            res = _context4.v;
            result = res.data || {}; // 确认: 替换 pending
            commit('PUSH_MESSAGE', {
              chatId: result.chatId || chatId,
              message: _objectSpread(_objectSpread({}, input), {}, {
                chatId: result.chatId || chatId,
                serverSeq: result.serverSeq || 0,
                clientMsgId: result.clientMsgId || clientMsgId,
                createdTime: new Date().toLocaleString(),
                _pending: false
              })
            });

            // 更新会话
            commit('UPDATE_CHAT_LAST_MESSAGE', {
              chatId: result.chatId || chatId,
              content: content,
              time: new Date().toLocaleString(),
              maxSeq: result.serverSeq
            });

            // 发送方发送成功后，自动将自己这端的已读游标推进到该条消息的 serverSeq，避免出现未读为 1 
            if (result.serverSeq) {
              dispatch('reportRead', {
                chatId: result.chatId || chatId,
                readSeq: result.serverSeq
              });
            }
            _context4.n = 6;
            break;
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            console.error('[Chat] sendMessage failed:', _t4);
            _context4.n = 4;
            return dispatch('recoverSentMessageByAck', {
              chatId: chatId,
              input: input,
              content: content
            });
          case 4:
            recovered = _context4.v;
            if (!recovered) {
              _context4.n = 5;
              break;
            }
            return _context4.a(2);
          case 5:
            // 标记失败
            commit('PUSH_MESSAGE', {
              chatId: chatId,
              message: _objectSpread(_objectSpread({}, pendingMsg), {}, {
                _pending: false,
                _failed: true
              })
            });
          case 6:
            return _context4.a(2);
        }
      }, _callee4, null, [[1, 3]]);
    }))();
  },
  /**
   * 发送图片消息
   */
  sendImageMessage: function sendImageMessage(_ref15, _ref16) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
      var commit, state, rootState, dispatch, chatId, imageUrl, user, clientMsgId, chat, input, pendingMsg, res, result, recovered, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref15.commit, state = _ref15.state, rootState = _ref15.rootState, dispatch = _ref15.dispatch;
            chatId = _ref16.chatId, imageUrl = _ref16.imageUrl;
            user = rootState.user;
            clientMsgId = 'web_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
            chat = state.chats.find(function (c) {
              return c.id === chatId;
            });
            input = buildSendInput({
              chatId: chatId,
              chat: chat,
              user: user,
              messageType: 2,
              content: '[图片]',
              link: imageUrl,
              clientMsgId: clientMsgId
            }); // 乐观插入
            pendingMsg = _objectSpread(_objectSpread({}, input), {}, {
              serverSeq: null,
              createdTime: new Date().toLocaleString(),
              _pending: true
            });
            commit('PUSH_MESSAGE', {
              chatId: chatId,
              message: pendingMsg
            });
            _context5.p = 1;
            _context5.n = 2;
            return postChatMessage(chat, input);
          case 2:
            res = _context5.v;
            result = res.data || {};
            commit('PUSH_MESSAGE', {
              chatId: result.chatId || chatId,
              message: _objectSpread(_objectSpread({}, input), {}, {
                chatId: result.chatId || chatId,
                serverSeq: result.serverSeq || 0,
                clientMsgId: result.clientMsgId || clientMsgId,
                createdTime: new Date().toLocaleString(),
                _pending: false
              })
            });
            commit('UPDATE_CHAT_LAST_MESSAGE', {
              chatId: result.chatId || chatId,
              content: '[图片]',
              time: new Date().toLocaleString(),
              maxSeq: result.serverSeq
            });
            if (result.serverSeq) {
              dispatch('reportRead', {
                chatId: result.chatId || chatId,
                readSeq: result.serverSeq
              });
            }
            _context5.n = 6;
            break;
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            console.error('[Chat] sendImageMessage failed:', _t5);
            _context5.n = 4;
            return dispatch('recoverSentMessageByAck', {
              chatId: chatId,
              input: input,
              content: '[图片]'
            });
          case 4:
            recovered = _context5.v;
            if (!recovered) {
              _context5.n = 5;
              break;
            }
            return _context5.a(2);
          case 5:
            commit('PUSH_MESSAGE', {
              chatId: chatId,
              message: _objectSpread(_objectSpread({}, pendingMsg), {}, {
                _pending: false,
                _failed: true
              })
            });
          case 6:
            return _context5.a(2);
        }
      }, _callee5, null, [[1, 3]]);
    }))();
  },
  retryMessage: function retryMessage(_ref17, _ref18) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
      var commit, state, rootState, dispatch, chatId, message, user, chat, newClientMsgId, matcher, input, res, result, recovered, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref17.commit, state = _ref17.state, rootState = _ref17.rootState, dispatch = _ref17.dispatch;
            chatId = _ref18.chatId, message = _ref18.message;
            if (!(!chatId || !message)) {
              _context6.n = 1;
              break;
            }
            return _context6.a(2);
          case 1:
            user = rootState.user;
            chat = state.chats.find(function (c) {
              return c.id === chatId;
            });
            newClientMsgId = 'web_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
            matcher = {
              clientMsgId: message.clientMsgId,
              id: message.id,
              serverSeq: message.serverSeq
            };
            input = buildSendInput({
              chatId: chatId,
              chat: chat,
              user: user,
              messageType: message.messageType || 1,
              content: message.content || '',
              link: message.link || '',
              clientMsgId: newClientMsgId
            });
            commit('UPDATE_MESSAGE_LOCAL_STATE', {
              chatId: chatId,
              matcher: matcher,
              patch: _objectSpread(_objectSpread({}, input), {}, {
                createdTime: new Date().toLocaleString(),
                _pending: true,
                _failed: false
              })
            });
            _context6.p = 2;
            _context6.n = 3;
            return postChatMessage(chat, input);
          case 3:
            res = _context6.v;
            result = res.data || {};
            commit('UPDATE_MESSAGE_LOCAL_STATE', {
              chatId: chatId,
              matcher: {
                clientMsgId: newClientMsgId
              },
              patch: _objectSpread(_objectSpread({}, input), {}, {
                chatId: result.chatId || chatId,
                serverSeq: result.serverSeq || 0,
                clientMsgId: result.clientMsgId || newClientMsgId,
                createdTime: new Date().toLocaleString(),
                _pending: false,
                _failed: false
              })
            });
            commit('UPDATE_CHAT_LAST_MESSAGE', {
              chatId: result.chatId || chatId,
              content: input.messageType === 2 ? '[图片]' : input.content,
              time: new Date().toLocaleString(),
              maxSeq: result.serverSeq
            });
            if (result.serverSeq) {
              dispatch('reportRead', {
                chatId: result.chatId || chatId,
                readSeq: result.serverSeq
              });
            }
            _context6.n = 7;
            break;
          case 4:
            _context6.p = 4;
            _t6 = _context6.v;
            console.error('[Chat] retryMessage failed:', _t6);
            _context6.n = 5;
            return dispatch('recoverSentMessageByAck', {
              chatId: chatId,
              input: input,
              content: input.messageType === 2 ? '[图片]' : input.content,
              matcher: {
                clientMsgId: newClientMsgId
              }
            });
          case 5:
            recovered = _context6.v;
            if (!recovered) {
              _context6.n = 6;
              break;
            }
            return _context6.a(2);
          case 6:
            commit('UPDATE_MESSAGE_LOCAL_STATE', {
              chatId: chatId,
              matcher: {
                clientMsgId: newClientMsgId
              },
              patch: {
                _pending: false,
                _failed: true
              }
            });
          case 7:
            return _context6.a(2);
        }
      }, _callee6, null, [[2, 4]]);
    }))();
  },
  recoverSentMessageByAck: function recoverSentMessageByAck(_ref19, _ref20) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
      var commit, state, dispatch, chatId, input, content, matcher, res, result, serverSeq, confirmedChatId, patch, localMatcher, existing, hasLocal, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref19.commit, state = _ref19.state, dispatch = _ref19.dispatch;
            chatId = _ref20.chatId, input = _ref20.input, content = _ref20.content, matcher = _ref20.matcher;
            if (input !== null && input !== void 0 && input.clientMsgId) {
              _context7.n = 1;
              break;
            }
            return _context7.a(2, false);
          case 1:
            _context7.p = 1;
            _context7.n = 2;
            return getMessageAck({
              clientMsgId: input.clientMsgId
            });
          case 2:
            res = _context7.v;
            result = res.data || {};
            serverSeq = readInt(result.serverSeq);
            confirmedChatId = result.chatId || chatId;
            if (!(!serverSeq || !confirmedChatId)) {
              _context7.n = 3;
              break;
            }
            return _context7.a(2, false);
          case 3:
            patch = _objectSpread(_objectSpread({}, input), {}, {
              chatId: confirmedChatId,
              serverSeq: serverSeq,
              clientMsgId: result.clientMsgId || input.clientMsgId,
              createdTime: new Date().toLocaleString(),
              _pending: false,
              _failed: false
            });
            localMatcher = matcher || {
              clientMsgId: input.clientMsgId
            };
            existing = state.messages[chatId] || [];
            hasLocal = existing.some(function (m) {
              return m.clientMsgId === localMatcher.clientMsgId;
            });
            if (hasLocal) {
              commit('UPDATE_MESSAGE_LOCAL_STATE', {
                chatId: chatId,
                matcher: localMatcher,
                patch: patch
              });
            } else {
              commit('PUSH_MESSAGE', {
                chatId: confirmedChatId,
                message: patch
              });
            }
            commit('UPDATE_CHAT_LAST_MESSAGE', {
              chatId: confirmedChatId,
              content: content,
              time: new Date().toLocaleString(),
              maxSeq: serverSeq
            });
            dispatch('reportRead', {
              chatId: confirmedChatId,
              readSeq: serverSeq
            });
            return _context7.a(2, true);
          case 4:
            _context7.p = 4;
            _t7 = _context7.v;
            console.warn('[Chat] recoverSentMessageByAck failed:', _t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 4]]);
    }))();
  },
  /**
   * 收到 SignalR 推送消息
   */
  receiveMessage: function receiveMessage(_ref21, message) {
    var _message$messageType, _ref22, _message$status, _rootState$user;
    var commit = _ref21.commit,
      state = _ref21.state,
      rootState = _ref21.rootState,
      dispatch = _ref21.dispatch;
    var chatId = message.chatId || message.ChatId;
    if (!chatId) return;
    var seq = message.serverSeq || message.ServerSeq;
    var msgClientId = message.clientMsgId || message.ClientMsgId;

    // serverSeq 去重
    var existing = state.messages[chatId] || [];
    if (seq && existing.find(function (m) {
      return m.serverSeq === seq;
    })) return;

    // clientMsgId 去重：跳过自己发送的消息（已通过乐观插入处理）
    if (msgClientId && existing.find(function (m) {
      return m.clientMsgId === msgClientId;
    })) {
      var idx = existing.findIndex(function (m) {
        return m.clientMsgId === msgClientId;
      });
      if (idx >= 0 && existing[idx]._pending) {
        Vue.set(existing, idx, _objectSpread(_objectSpread({}, existing[idx]), {}, {
          serverSeq: seq,
          _pending: false
        }));
      }
      return;
    }
    var normalized = normalizeIncomingMessage({
      id: message.id || message.Id,
      chatId: chatId,
      senderId: message.senderId || message.SenderId,
      senderName: message.senderName || message.SenderName,
      senderAvatar: message.senderAvatar || message.SenderAvatar,
      senderType: message.senderType || message.SenderType,
      receiveId: message.receiveId || message.ReceiveId,
      receiveName: message.receiveName || message.ReceiveName,
      receiveType: message.receiveType || message.ReceiveType,
      messageType: (_message$messageType = message.messageType) !== null && _message$messageType !== void 0 ? _message$messageType : message.MessageType,
      content: message.content || message.Content,
      link: message.link || message.Link,
      serverSeq: seq,
      clientMsgId: msgClientId,
      status: (_ref22 = (_message$status = message.status) !== null && _message$status !== void 0 ? _message$status : message.Status) !== null && _ref22 !== void 0 ? _ref22 : 0,
      createdTime: message.createdTime || message.CreatedTime || new Date().toLocaleString()
    });
    commit('PUSH_MESSAGE', {
      chatId: chatId,
      message: normalized
    });
    commit('UPDATE_CHAT_LAST_MESSAGE', {
      chatId: chatId,
      content: normalized.content,
      time: normalized.createdTime,
      maxSeq: normalized.serverSeq
    });
    var chatMetaPatch = buildChatMetaPatchFromMessage(normalized);
    if (chatMetaPatch) {
      commit('UPDATE_CHAT_META', {
        chatId: chatId,
        patch: chatMetaPatch
      });
    }

    // 如果不在当前聊天窗口，增加未读计数
    if (state.currentChatId !== chatId) {
      var chat = state.chats.find(function (c) {
        return c.id === chatId;
      });
      if (chat) {
        chat.unreadCount = (chat.unreadCount || 0) + 1;
        state.unreadCount = state.chats.reduce(function (sum, c) {
          return sum + (c.unreadCount || 0);
        }, 0);
      }
    } else if (state.drawerOpen && normalized.serverSeq) {
      // 正在看这个会话 → 自动上报已读，保持服务端 unreadCount 同步
      dispatch('reportRead', {
        chatId: chatId,
        readSeq: normalized.serverSeq
      });
    }

    // 是否需要弹 toast：Drawer 未打开 或者打开了但不在这个 chat 的详情页
    var senderId = normalized.senderId;
    var myUserId = (_rootState$user = rootState.user) === null || _rootState$user === void 0 ? void 0 : _rootState$user.userId;
    var isMine = String(senderId) === String(myUserId);
    var shouldToast = !isMine && (!state.drawerOpen || state.currentChatId !== chatId);
    if (shouldToast) {
      var now = Date.now();
      var lastToast = _toastThrottleMap[chatId] || 0;
      if (now - lastToast > 3000) {
        _toastThrottleMap[chatId] = now;
        commit('SET_PENDING_TOAST', {
          chatId: chatId,
          senderName: normalized.senderName || '未知',
          content: normalized.content || ''
        });
      }
    }
    var isViewingCurrentChat = state.drawerOpen && state.currentChatId === chatId;
    var shouldDesktopNotify = !isMine && !isViewingCurrentChat;
    if (shouldDesktopNotify) {
      desktopNotify.show(normalized.senderType === 0 ? '系统通知' : normalized.senderName || '系统通知', buildDesktopNotifyBody(normalized), resolveDesktopNotifyIcon());
    }
  },
  /**
   * 收到已读游标变更
   */
  updateReadCursor: function updateReadCursor(_ref23, payload) {
    var commit = _ref23.commit;
    var chatId = payload.chatId || payload.ChatId;
    var readSeq = payload.readSeq || payload.ReadSeq;
    if (chatId && readSeq) {
      commit('UPDATE_READ_CURSOR', {
        chatId: chatId,
        readSeq: readSeq
      });
    }
  },
  /**
   * 上报已读
   */
  reportRead: function reportRead(_ref24, _ref25) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
      var commit, chatId, readSeq, _t8;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref24.commit;
            chatId = _ref25.chatId, readSeq = _ref25.readSeq;
            _context8.p = 1;
            _context8.n = 2;
            return postRead({
              chatId: chatId,
              readSeq: readSeq
            });
          case 2:
            commit('UPDATE_READ_CURSOR', {
              chatId: chatId,
              readSeq: readSeq
            });
            _context8.n = 4;
            break;
          case 3:
            _context8.p = 3;
            _t8 = _context8.v;
            console.error('[Chat] reportRead failed:', _t8);
          case 4:
            return _context8.a(2);
        }
      }, _callee8, null, [[1, 3]]);
    }))();
  },
  /**
   * 撤回消息
   */
  doRecallMessage: function doRecallMessage(_ref26, _ref27) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9() {
      var commit, chatId, messageId, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref26.commit;
            chatId = _ref27.chatId, messageId = _ref27.messageId;
            _context9.p = 1;
            _context9.n = 2;
            return recallMessage({
              messageId: messageId
            });
          case 2:
            commit('RECALL_MESSAGE', {
              chatId: chatId,
              messageId: messageId
            });
            _context9.n = 4;
            break;
          case 3:
            _context9.p = 3;
            _t9 = _context9.v;
            console.error('[Chat] recallMessage failed:', _t9);
          case 4:
            return _context9.a(2);
        }
      }, _callee9, null, [[1, 3]]);
    }))();
  },
  /**
   * 收到 SignalR 消息撤回通知
   */
  handleMessageRecalled: function handleMessageRecalled(_ref28, payload) {
    var commit = _ref28.commit,
      state = _ref28.state;
    var chatId = payload.chatId || payload.ChatId;
    var messageId = payload.messageId || payload.MessageId;
    var serverSeq = payload.serverSeq || payload.ServerSeq;
    if (chatId) {
      commit('RECALL_MESSAGE', {
        chatId: chatId,
        messageId: messageId,
        serverSeq: serverSeq
      });
    }
  },
  /**
   * 创建新会话
   */
  createNewChat: function createNewChat(_ref29, user) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0() {
      var commit, rootState, currentUser, clientMsgId, input, res, chat, _t0;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            commit = _ref29.commit, rootState = _ref29.rootState;
            currentUser = rootState.user;
            clientMsgId = 'web_' + Date.now() + '_' + Math.random().toString(36).substr(2, 6);
            input = {
              senderId: currentUser.userId,
              senderType: 1,
              senderName: currentUser.name,
              senderAvatar: currentUser.avatar || '',
              receiveId: user.id,
              receiveType: 1,
              receiveName: user.name,
              receiveAvatar: user.avatar || '',
              messageType: 1,
              content: '你好',
              clientMsgId: clientMsgId
            };
            _context0.p = 1;
            _context0.n = 2;
            return createChat(input);
          case 2:
            res = _context0.v;
            chat = res.data;
            if (!chat) {
              _context0.n = 3;
              break;
            }
            commit('ADD_CHAT', {
              id: chat.id,
              name: user.name,
              avatar: user.avatar || '',
              userId: user.id,
              userType: 1,
              lastMessage: '你好',
              lastMessageTime: new Date().toLocaleString(),
              maxSeq: 0,
              myReadSeq: 0,
              unreadCount: 0
            });
            return _context0.a(2, chat.id);
          case 3:
            _context0.n = 5;
            break;
          case 4:
            _context0.p = 4;
            _t0 = _context0.v;
            console.error('[Chat] createNewChat failed:', _t0);
          case 5:
            return _context0.a(2, null);
        }
      }, _callee0, null, [[1, 4]]);
    }))();
  }
};
export default {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};